// --- ROUTE TYPE ---
export interface RouterMenuProps {
  id: number
  path?: string
  parent_id: number | null
  icon?: string
  label: string
  key: string
  slug?: string
  isGuestRoute?: boolean
  isUserRoute?: boolean
  permission_slugs: string[] | string
  slugOptions?: string[]
  breadcrumb?: string[]
  isDetails?: boolean
  isExpanded?: boolean
  isSidebarMenu?: boolean
  hasChild?: boolean
  hasDivider?: boolean
  pathOverride?: string
  isAuthRoute?: boolean
  publicPermission?: boolean
  beforeIcon?: string
  afterIcon?: string
  children?: {
    slug: string
  }[]
}

// --- ROUTE CONFIGURATION ---
export const router_config: { [key: string]: RouterMenuProps } = {
  // HOME
  HOME: {
    id: 0,
    path: '/',
    parent_id: null,
    label: 'Home',
    key: 'home',
    permission_slugs: [],
  },

  AUTH_HOME: {
    id: 0,
    path: '/home',
    parent_id: null,
    label: 'Home',
    key: 'home',
    permission_slugs: [],
  },

  // ABOUT US PARENT
  ABOUT_US: {
    id: 10,
    path: '/about-us',
    parent_id: null,
    label: 'About Us',
    key: 'about_us',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
    hasChild: true,
  },

  ABOUT_US_AUTH: {
    id: 10,
    path: '/about-us',
    parent_id: null,
    label: 'About Us',
    key: 'about_us',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
    hasChild: true,
  },

  // ABOUT US CHILDREN
  ABOUT_KIED: {
    id: 11,
    path: '/about-us/kied',
    parent_id: 10,
    label: 'About KIED',
    key: 'about_kied',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },
  OUR_MEMBERS: {
    id: 12,
    path: '/about-us/our-members',
    parent_id: 10,
    label: 'Council Members',
    key: 'our_members',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },
  OUR_TEAM: {
    id: 12,
    path: '/about-us/our-team',
    parent_id: 10,
    label: 'Our Team',
    key: 'our_team',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },

  CONTACT_US: {
    id: 13,
    path: '/about-us/contact',
    parent_id: 10,
    label: 'Contact Us',
    key: 'contact_us',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },

  // INFORMATION
  INFORMATION: {
    id: 20,
    path: '/information',
    parent_id: null,
    label: 'Information',
    key: 'information',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },

  CAREERS: {
    id: 21,
    path: '/information/careers',
    parent_id: 20,
    label: 'Careers',
    key: 'careers',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },
  INTERNSHIPS: {
    id: 22,
    path: '/information/internships',
    parent_id: 20,
    label: 'Internships',
    key: 'internships',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },
  // TENDERS: {
  //   id: 23,
  //   path: '/information/tenders',
  //   parent_id: 20,
  //   label: 'Tenders',
  //   key: 'tenders',
  //   permission_slugs: [
  //     'aspering_ent',
  //     'schools',
  //     'research',
  //     'existing_ent',
  //     'industry_asso',
  //     'mentors',
  //     'edclub',
  //     'students',
  //     'guest',
  //   ],
  // },

  TRAININGCALENDAR: {
    id: 24,
    path: '/initiatives/training-calendar',
    parent_id: 20,
    label: 'Training Calendar',
    key: 'training_calendar',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },
  EDC: {
    id: 23,
    path: '/initiatives/edc',
    parent_id: 20,
    label: 'EDC',
    key: 'edc',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },
  // NBFC: {
  //   id: 23,
  //   path: '/initiatives/nbfc',
  //   parent_id: 20,
  //   label: 'NBFC',
  //   key: 'nbfc',
  //   permission_slugs: [
  //     'aspering_ent',
  //     'schools',
  //     'research',
  //     'existing_ent',
  //     'industry_asso',
  //     'mentors',
  //     'edclub',
  //     'students',
  //     'guest',
  //   ],
  // },
  UPCOMMINGEVENTS: {
    id: 25,
    path: '/initiatives/upcomming-events',
    parent_id: 20,
    label: 'Upcoming Events',
    key: 'upcoming_events',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },
  UPCOMMINGEVENTS_FORM: {
    id: 25,
    path: '/initiatives/upcomming-events-form',
    parent_id: 106,
    label: 'Upcoming Events',
    key: 'upcoming_events',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },
  UPCOMMINGEVENTS_DETAIL: {
    id: 25,
    path: '/initiatives/upcomming-events-detail',
    parent_id: 106,
    label: 'Upcoming Events',
    key: 'upcoming_events',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },

  PUBLICATIONS_AND_NEWSLETTERS: {
    id: 26,
    path: '/resources/publications',
    parent_id: 20,
    label: 'Publications And Newsletters',
    key: 'publications',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },
  MATERIALS: {
    id: 27,
    path: '/resources/materials',
    parent_id: 20,
    label: 'Materials',
    key: 'materials',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },
  SCHEMES: {
    id: 28,
    path: '/resources/schemes',
    parent_id: 20,
    label: 'Schemes',
    key: 'schemes',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },
  FACILITATION: {
    id: 31,
    path: '/departments/facilitation',
    parent_id: 20,
    label: 'Facilitation',
    key: 'facilitation',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },
  FACILITATION_FORM: {
    id: 31,
    path: '/departments/facilitation/form',
    parent_id: 20,
    label: 'Facilitation Form',
    key: 'facilitation_form',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },
  TECHNOLOGY_TRANSFER: {
    id: 33,
    path: '/departments/technologytransfer',
    parent_id: 20,
    label: 'TechnologyTransfer',
    key: 'technologytransfer',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },
  INDUSTRY_ACADEMY_COLLABORATION: {
    id: 34,
    path: '/departments/industryacademycollaboration',
    parent_id: 20,
    label: 'IndustryAcademyCollaboration',
    key: 'industryacademycollaboration',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },
  TECH_HORIZON: {
    id: 35,
    path: '/departments/learning/program-details/:id',
    parent_id: 20,
    label: 'Tech-Horizon',
    key: 'techhorizon',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },

  ANNUALREPORTS: {
    id: 29,
    path: '/resources/annual-reports',
    parent_id: 20,
    label: 'Annual Reports',
    key: 'annual_reports',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },
  LEARNING: {
    id: 53,
    path: '/departments/learning',
    parent_id: 20,
    label: 'Learning',
    key: 'learning',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },
  INTERNSHIPFORM: {
    id: 52,
    path: '/information/internship-form',
    parent_id: 20,
    label: 'Internship Form',
    key: 'internship_form',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },
  INCUBATION: {
    id: 50,
    path: '/departments/incubation',
    parent_id: 20,
    label: 'incubation',
    key: 'incubation',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },
  INCUBATION_FORM: {
    id: 51,
    path: '/departments/incubation-form',
    parent_id: 20,
    label: 'Incubation-form',
    key: 'Incubation-form',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },
  INCUBATION_VIEW: {
    id: 51,
    path: '/departments/incubation-view',
    parent_id: 20,
    label: 'Incubation-form',
    key: 'Incubation-form',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },
  REDRESSAL: {
    id: 54,
    path: '/information/redressal',
    parent_id: 20,
    label: 'redressal',
    key: 'redressal',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },
  ACADEMIC_FORM: {
    id: 38,
    path: '/departments/academic-form',
    parent_id: 20,
    label: 'academic_form',
    key: 'academic_form',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },

  GALLERY_VIDEO: {
    id: 57,
    path: '/video_gallery',
    parent_id: 20,
    label: 'video_gallery',
    key: 'video_gallery',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },
  GALLERY_PHOTO: {
    id: 57,
    path: '/photo_gallery',
    parent_id: 20,
    label: 'photo_gallery',
    key: 'photo_gallery',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },
  LOGIN: {
    id: 60,
    path: '/login',
    parent_id: 20,
    label: 'login',
    key: 'login',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },
  REGISTRATION: {
    id: 61,
    path: '/registration',
    parent_id: 20,
    label: 'registration',
    key: 'registration',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },
  VERIFYEMAIL: {
    id: 61,
    path: '/verify-email/:id',
    parent_id: 20,
    label: 'verify-email',
    key: 'verify-email',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },
  RESETPASSWORD: {
    id: 62,
    path: '/reset-password/:id',
    parent_id: 20,
    label: 'reset-password',
    key: 'reset-password',
    permission_slugs: [],
  },
  TERMSANDCONDITION: {
    id: 72,
    path: '/terms',
    parent_id: 20,
    label: 'terms-and-condition',
    key: 'terms-and-condition',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },

  RTI: {
    id: 21,
    path: '/information/rti',
    parent_id: 20,
    label: 'RTI',
    key: 'rti',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },
  ACTS_RULES_GOVERNMENT_ORDERS: {
    id: 46,
    path: '/information/actsandrules',
    parent_id: 20,
    label: 'Acts,Rules and Government Orders(GO)',
    key: 'actsandrules',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },

  // // DASHBOARD
  // DASHBOARD: {
  //   id: 100,
  //   path: '/dashboard',
  //   parent_id: null,
  //   label: 'Dashboard',
  //   key: 'dashboard',
  //   permission_slugs: ['Super Admin', 'Admin'],
  //   beforeIcon: 'dashboard-icon',
  //   afterIcon: 'dashboard-icon',
  //   isSidebarMenu: true,
  // },

  // EXAMPLE ADMIN ROUTES
  ADMIN_USER: {
    id: 110,
    path: '/admin-user',
    parent_id: null,
    label: 'Administrators',
    key: 'admin_user',
    permission_slugs: ['Super Admin'],
    isSidebarMenu: true,
    beforeIcon: 'user-icon',
    afterIcon: 'user-icon',
  },

  FAQ_ADMIN: {
    id: 111,
    path: '/admin-faq',
    parent_id: null,
    label: 'FAQ',
    key: 'admin_faq',
    permission_slugs: ['Super Admin'],
    isSidebarMenu: true,
    beforeIcon: 'faq-icon',
    afterIcon: 'faq-icon',
  },

  DASHBOARD: {
    id: 100,
    path: '/dashboard',
    parent_id: null,
    label: 'Dashboard',
    key: 'dashboard',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
    isSidebarMenu: true,
    hasChild: true,
  },

  DASHBOARD_FACILITATION: {
    id: 101,
    path: '/dashboard/facilitations',
    parent_id: 100,
    label: 'Facilitations',
    key: 'dashboard_facilitations',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
    isSidebarMenu: true,
  },

  // Dashboard Tables subsections
  DASHBOARD_TABLES_INCUBATION: {
    id: 1040,
    path: '/dashboard/incubation',
    parent_id: 100,
    label: 'Incubation Applications',
    key: 'dashboard_tables_incubation',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
    isSidebarMenu: false,
  },
  DASHBOARD_TABLES_PROGRAMS: {
    id: 1041,
    path: '/dashboard/programs',
    parent_id: 100,
    label: 'Registered Programs',
    key: 'dashboard_tables_programs',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
    isSidebarMenu: false,
  },
  DASHBOARD_TABLES_FACILITATIONS: {
    id: 1042,
    path: '/dashboard/facilitations',
    parent_id: 100,
    label: 'Facilitation Services',
    key: 'dashboard_tables_facilitations',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
    isSidebarMenu: false,
  },
  DASHBOARD_UPCOMING_PROGRAMS: {
    id: 1043,
    path: '/dashboard/upcoming-programs',
    parent_id: 100,
    label: 'Upcoming Programs',
    key: 'dashboard_upcoming_programs',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
    isSidebarMenu: true,
  },
  DASHBOARD_FACILITATION_DETAIL: {
    id: 101,
    path: '/dashboard/facilitation-detail/:id',
    parent_id: 100,
    label: 'Facilitation Detail',
    key: 'dashboard_facilitation_detail',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
    isSidebarMenu: false,
  },

  DASHBOARD_REPORTS: {
    id: 102,
    path: '/dashboard/reports',
    parent_id: 100,
    label: 'Reports',
    key: 'dashboard_reports',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
    isSidebarMenu: true,
  },
  DASHBOARD_PROFILE: {
    id: 109,
    path: '/dashboard/profile-details',
    parent_id: 100,
    label: 'Profile',
    key: 'dashboard_profile',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
    isSidebarMenu: true,
  },

  DASHBOARD_SETTINGS: {
    id: 103,
    path: '/dashboard/settings',
    parent_id: 100,
    label: 'Payment Status',
    key: 'dashboard_settings',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
    isSidebarMenu: true,
  },
  DASHBOARD_CERTIFICATE: {
    id: 104,
    path: '/dashboard/certificate',
    parent_id: null,
    label: 'Certificate',
    key: 'dashboard_certificate',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
    isSidebarMenu: true,
    hasChild: true,
  },

  DYNAMIC_FORM: {
    id: 105,
    path: '/departments/learning/form/:id',
    parent_id: 20,
    label: 'Dynamic Form',
    key: 'dynamic_form',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },
  NBFC: {
    id: 118,
    path: '/initiatives/nbfc',
    parent_id: 20,
    label: 'nbfc Form',
    key: 'nbfc_form',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },

  PROFILE_DETAILS: {
    id: 106,
    path: '/dashboard/profile-details',
    parent_id: 20,
    label: 'Dynamic Form',
    key: 'dynamic_form',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },
  TENDERS: {
    id: 109,
    path: '/tenders',
    parent_id: 20,
    label: 'tenders',
    key: 'tenders',
    permission_slugs: [
      'aspering_ent',
      'schools',
      'research',
      'existing_ent',
      'industry_asso',
      'mentors',
      'edclub',
      'students',
      'guest',
    ],
  },
}
